<template>
    <div id="interventiondetailadmin">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burger.png" alt="burger" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
            <div class="sideNav" :style="{ width: navWidth + 'px' }">
                <div class="leftNav">
                    <div class="innerNav">
                        <img class="navLogout" v-on:click="openNav()" src="/assets/burgerwhite.png" alt="burger" />
                    </div>
                </div>
                <div v-if="navMenuVisible" class="navsidecontent">
                    <div class="navtitle noborder">
                        Gérer les biens et demandes
                    </div>
                    <div v-on:click="goToNewBuildingPage" class="navsubtitle">
                        Créer un nouveau bien
                    </div>
                    <div v-on:click="goToBuildingPage" class="navsubtitle">
                        Consulter/Modifier les biens et demandes
                    </div>
                    <div class="navtitle">
                        Plannings
                    </div>
                    <div v-on:click="goToPlanningPage" class="navsubtitle">
                        Consulter/Modifier les plannings
                    </div>
                    <div v-on:click="goToTimeSheetPage" class="navsubtitle">
                        Fiches horaires
                    </div>
                    <div class="navtitle">
                        Groupes
                    </div>
                    <div v-on:click="goToNewGroupPage" class="navsubtitle">
                        Ajouter un groupe
                    </div>
                    <div v-on:click="goToAllGroupPage" class="navsubtitle">
                        Voir/Modifier les groupes
                    </div>
                    <div class="navtitle">
                        Utilisateurs
                    </div>
                    <div v-on:click="goToNewUserPage" class="navsubtitle">
                        Ajouter un utilisateur
                    </div>
                    <div v-on:click="goToAllUserPage" class="navsubtitle">
                        Voir/Modifier les utilisateurs
                    </div>
                    <div v-on:click="logout()" class="navtitle logout">
                        Déconnexion
                    </div>
                </div>
            </div>
        </nav>
        <div class="filAriane">
            <span v-html="filAriane"></span>
        </div>
        <div class="outercircle">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            {{intervention.name}} &nbsp;&nbsp;-&nbsp;&nbsp; {{intervention.status}}
        </h1>
        <div class="greyBack">
            <div class="title"><b>{{intervention.type}}</b></div>
            <div class="date"><i>{{date}}</i></div>
            <div class="img">
                <div v-on:click="changeSheetState()" class="oneImg"><img src="/assets/pdf.png" alt="PDF" /><span>Fiche d'intervention</span></div>
                    <div id="myModal" v-on:click="changeSheetState()" v-bind:class="[isActiveSheet ? 'modalActive' : 'modalInactive']">
                        <span class="close">&times;</span>
                        <img v-if="!intervention.intervention" class="modal-content whiteback" v-on:click.stop="" src="/assets/nosheet.png">
                        <div v-else class="modal-content whiteback">
                            <h2>Fiche d'intervention</h2>
                            <h4>Coordonnées :</h4>
                            <div class="modalTxt twocolumns" style="text-align:left !important; margin-left:20px;margin-right:20px;">
                                <div v-html="txtLocataire"></div>
                                <div v-html="txtProprio"></div>
                            </div>
                            <h4>Informations :</h4>
                            <div>
                                <div class="smallFont" v-for="(itemInfo, indexInfo) in intervention.intervention.information" :key="indexInfo">
                                    <div class="modalDivCenter">
                                        <span>{{itemInfo.note}}</span><br>
                                        <span>{{itemInfo.status}}</span>
                                    </div>
                                </div>
                            </div>
                            <h4>Actions :</h4>
                            <div>
                                <div class="smallFont" v-for="(itemAction, indexAction) in intervention.intervention.action" :key="indexAction">
                                    <div v-if="itemAction.isInternal || itemAction.isExternal" style="background-coor:#ddd; border-radius: 5px;"  class="modalDivCenter">
                                        <span><b>{{itemAction.name}} :</b></span><br>
                                        <span v-if="itemAction.isInternal">Interne</span>
                                        <span v-if="itemAction.isExternal">Externe</span>
                                        <b style="display:block;">Travail effectué :</b>
                                        <span>{{itemAction.report}}</span><br><br>
                                    </div>
                                </div>
                            </div>
                            <h4>Temps d'intervention :</h4>
                            <div class="textline smallFont">
                                <b class="textLen">Temps technicien principal :</b>
                                <span>{{mainTechHour}} h </span>
                                <span>{{mainTechMinute}} min </span>
                            </div> 
                            <div class="textline smallFont" v-for="(itemInterim, indexInterim) in interimHour" :key="indexInterim">
                                <b class="textLen">Temps intérimaire :</b>
                                <span>{{interimHour[indexInterim]}} h </span>
                                <span>{{interimMinute[indexInterim]}} min </span>
                            </div> 
                            <div class="textline smallFont" v-for="help in helpHour.length" :key="help">
                                <b class="textLen">Temps technicien aide :</b>
                                <span>{{helpHour[help-1]}} h </span>
                                <span>{{helpMinute[help-1]}} min </span>
                            </div> 
                            <div class="textline smallFont">
                                <b class="textLen">Temps passé cumulé :</b>
                                <span>{{cumulateHour}} h </span>
                                <span>{{cumulateMinute}} min </span>
                            </div> 
                            <h4>Signatures :</h4>
                            <div class="divSigImg smallFont">
                                <span>Technicien : </span><br>
                                <img :src="dataUrlTech()" class="sigImg" alt="tech" >
                            </div>
                            <div class="divSigImg smallFont">
                                <span>Client : </span><br>
                                <img :src="dataUrlCust()" class="sigImg" alt="tech" >
                            </div>
                        </div>
                    </div>
                <div v-on:click="changeNoticeState()" class="oneImg"><img src="/assets/pdf.png" alt="PDF" /><span>Avis de passage</span></div>
                    <div id="myModal" v-on:click="changeNoticeState()" v-bind:class="[isActiveNotice ? 'modalActive' : 'modalInactive']">
                        <span class="close">&times;</span>
                        <img v-if="!intervention.noticeFiled" class="modal-content whiteback" v-on:click.stop="" src="/assets/nonotice.png">
                        <div v-else class="modal-content whiteback">
                            <h2>Avis de passage</h2>
                            <div style="color:black;">
                                <b>Type :</b>
                                <i v-if="intervention.noticeFiled.isWaterBreak">Avis de coupure d'eau</i>
                                <i v-else>Avis de passage</i>
                                <br>
                                <b v-if="intervention.noticeFiled.isWaterBreak">Début de coupure :</b>
                                <b v-else>Début de passage :</b>
                                <i>{{displayedHour(intervention.noticeFiled.startTimestamp)}}</i>
                                <br>
                                <b v-if="intervention.noticeFiled.isWaterBreak">Fin de coupure :</b>
                                <b v-else>Fin de passage :</b>
                                <i>{{displayedHour(intervention.noticeFiled.endTimestamp)}}</i>
                                <br>
                                <img :src="dataUrlNotice()">
                            </div>
                        </div>
                    </div>
                <div v-on:click="chageSketchState()" class="oneImg"><img src="/assets/img.png" alt="PDF" /><span>Croquis</span></div>
                    <div id="myModal" v-on:click="chageSketchState()" v-bind:class="[isActiveSketch ? 'modalActive' : 'modalInactive']">
                        <span class="close">&times;</span>
                        <img class="modal-content whiteback" v-on:click.stop="" :src="dataUrlSketch()">
                    </div>
                <div v-for="(item, index) in intervention.picture" :key="index" class="allImg">
                    <div v-on:click="chageModalState(index)" class="oneImg"><img data-lightbox="example-set" src="/assets/img.png" alt="PDF" /><span>Photo {{index+1}}</span></div>
                    <div id="myModal" v-on:click="chageModalState(index)"  v-bind:class="[isActive[index] ? 'modalActive' : 'modalInactive']">
                        <span class="close">&times;</span>
                        <img class="modal-content" v-on:click.stop="" :src="dataUrl(index)">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'interventiondetailadmin',
        data() {
            return {
                intervention : {},
                inquiry:{},
                building:{},
                txtLocataire:"<b class='textLenSheet'>Locataire :</b> Coordonnées inconnues<br><br><br><br>",
                txtProprio:"<b class='textLenSheet'>Propriétaire :</b> Coordonnées inconnues<br><br><br><br>",
                mainTechHour:"0",
                mainTechMinute:"0",
                interimHour:["0"],
                interimMinute:["0"],
                helpHour:["0"],
                helpMinute:["0"],
                cumulateHour:"0",
                cumulateMinute:"0",
                Name:"client",
                date: "01/01/2019",
                isActive: [],
                isActiveSketch: false,
                isActiveNotice: false,
                isActiveSheet: false,
                navWidth:0,
                navMenuVisible:false,
                filAriane: ""
            };
        },
        methods:{
            dataUrlCust(){
                if(this.intervention.customerSignature){
                    return 'data:'+this.intervention.customerSignature.img.contentType+';base64,' + btoa(
                        new Uint8Array(this.intervention.customerSignature.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                }
                else{
                    return "/assets/nosignature.png";
                }
            },
            dataUrlTech(){
                if(this.intervention.techSignature){
                    return 'data:'+this.intervention.techSignature.img.contentType+';base64,' + btoa(
                        new Uint8Array(this.intervention.techSignature.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                }
                else{
                    return "/assets/nosignature.png";
                }
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('historyQuery');
                this.$cookie.delete('history');
                this.$router.replace({ name: "login" });
            },
            openNav(){
                 
                if(!this.navWidth){
                    this.navWidth = 300;
                }
                else{
                    this.navWidth = 0;
                }
                
                var vm = this;
                setTimeout(function(){
                    vm.navMenuVisible = !vm.navMenuVisible;
                }, 100);
            },
            goToBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildinglist"});
            },
            goToNewBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newbuilding"});
            },
            goToPlanningPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "planningadmin"});
            },
            goToTimeSheetPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "timesheet"});
            },
            goToAllUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "alluser"});
            },
            goToNewUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newuser"});
            },
            goToAllGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "allgroup"});
            },
            goToNewGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newgroup"});
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "adminhome" });
            },
            chageSketchState(){
                this.isActiveSketch = !this.isActiveSketch;
            },
            changeNoticeState(){
                this.isActiveNotice = !this.isActiveNotice;
            },
            changeSheetState(){
                this.isActiveSheet = !this.isActiveSheet;
            },
            displayedHour(t){
                var n = new Date(t*1000);
                var y = n.getFullYear();
                var day = "0" + n.getDate();
                var month = "0" + (n.getMonth() + 1);
                var hours = "0" + n.getHours();
                var minutes = "0" + n.getMinutes();
                return  hours.substr(-2) + 'h' + minutes.substr(-2)+" " + day.substr(-2) + '/' + month.substr(-2) + '/' +y;   
            },
            dataUrlSketch(){
                if(this.intervention.sketch){
                    return 'data:'+this.intervention.sketch.img.contentType+';base64,' + btoa(
                        new Uint8Array(this.intervention.sketch.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                }
                else{
                    return "/assets/empty.png";
                }
            },
            dataUrlNotice(){
                if(this.intervention.noticeFiled){
                    if(this.intervention.noticeFiled.picture){
                        return 'data:'+this.intervention.noticeFiled.picture.img.contentType+';base64,' + btoa(
                            new Uint8Array(this.intervention.noticeFiled.picture.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                        );
                    }
                    else{
                        return "/assets/empty.png";
                    }
                }
                else{
                    return "/assets/empty.png";
                }
            },
            dataUrl(i){
                return 'data:'+this.intervention.picture[i].img.contentType+';base64,' + btoa(
                    new Uint8Array(this.intervention.picture[i].img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
            },
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "adminhome" });
                }
            },				
            getCookies: function() {
                this.filAriane = this.$cookie.get('currentAriane');
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || (this.$cookie.get('role') !== "admin" && this.$cookie.get('role') !== "technicien bureau") || !this.$route.query.name){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getIntervention();
                }
            },
            chageModalState(i){
                var state = !this.isActive[i];
                this.isActive.splice(i, 1);
                this.isActive.splice(i, 0,state);
            },
            getDateOfIntervention(timestamp){
                var n = new Date(timestamp*1000);
                var y = n.getFullYear();
                var day = "0" + n.getDate();
                var month = "0" + (n.getMonth() + 1);
                return  day.substr(-2) + '/' + month.substr(-2) + '/' +y;                            
            },
            async getInquiry(id){
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/fromintervention/'+id);
                if(response.data.inquiry){
                    this.inquiry = response.data.inquiry;
                    this.getBuilding(this.inquiry.name);
                }
            },
            async getBuilding(name){
                var response = await axios.get('https://so.gaviota.fr/api/building/frominquiry/'+name);
                if(response.data.building){
                    this.building = response.data.building;

                    if(this.building.occupantAddress.length){
                        if(this.building.occupantAddress[0].firstName !== "" ||
                            this.building.occupantAddress[0].lastName !== "" || 
                            this.building.occupantAddress[0].streetNb !== "" || 
                            this.building.occupantAddress[0].streetName !== "" || 
                            this.building.occupantAddress[0].postalCode !== "" || 
                            this.building.occupantAddress[0].city !== "" || 
                            this.building.occupantAddress[0].phoneNumber !== "" || 
                            this.building.occupantAddress[0].emailAddress !== ""
                        ){
                            this.txtLocataire = "<b class='textLenSheet'>Locataire :&nbsp;&nbsp;</b>"+
                                                this.building.occupantAddress[0].firstName + " "+this.building.occupantAddress[0].lastName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].streetNb + " "+this.building.occupantAddress[0].streetName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].postalCode + " "+this.building.occupantAddress[0].city+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].phoneNumber +'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].emailAddress;
                        }
                    }
                    if(this.building.ownerAddress){
                        if(this.building.ownerAddress.firstName !== "" ||
                            this.building.ownerAddress.lastName !== "" || 
                            this.building.ownerAddress.streetNb !== "" || 
                            this.building.ownerAddress.streetName !== "" || 
                            this.building.ownerAddress.postalCode !== "" || 
                            this.building.ownerAddress.city !== "" || 
                            this.building.ownerAddress.phoneNumber !== "" || 
                            this.building.ownerAddress.emailAddress !== ""
                        ){
                            this.txtProprio =   "<b class='textLenSheet'>Propriétaire :&nbsp;&nbsp;</b>"+
                                                this.building.ownerAddress.firstName + " "+this.building.ownerAddress.lastName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.ownerAddress.streetNb + " "+this.building.ownerAddress.streetName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                +this.building.ownerAddress.postalCode + " "+this.building.ownerAddress.city+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.ownerAddress.phoneNumber +'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.ownerAddress.emailAddress;
                        }
                    }
                }
            },
            async getIntervention(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/intervention/'+this.$route.query.name)
                if(response.data.intervention){
                    this.intervention = response.data.intervention;
                    this.date = this.getDateOfIntervention(this.intervention.planning[0].startTimestamp)
                    for(var i=0; i<this.intervention.picture.length; i++){
                        this.isActive.push(false);
                    }
                    var LOCmainTechTime =0;
                    var LOCinterimTime =[];
                    var LOChelpTime =[];
                    var LOCcumulateTime =0;
                    var foundHelp = false;
                    var foundInt = false;

                    for(var f=0; f<this.intervention.planning.length; f++){
                        if(!this.intervention.planning[f].isEstimated){
                            if(!this.intervention.planning[f].isEstimated && this.intervention.planning[f].isMain){
                                LOCmainTechTime += this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                            }
                            if(!this.intervention.planning[f].isEstimated && !this.intervention.planning[f].isMain && this.intervention.planning[f].user.idWeweb.indexOf("interimaire")===-1){
                                foundHelp = false;
                                for(var g=0; g<LOChelpTime.length; g++){
                                    if(LOChelpTime[g].user === this.intervention.planning[f].user.idWeweb){
                                        foundHelp = true;
                                        LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                        LOChelpTime[g].time = LOChelpTime[g].time + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    }
                                }
                                if(!foundHelp){
                                    LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    LOChelpTime.push({time:this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp, user:this.intervention.planning[f].user.idWeweb});
                                }
                            }
                            if(!this.intervention.planning[f].isEstimated && this.intervention.planning[f].isMain && this.intervention.planning[f].user.idWeweb.indexOf("interimaire") > -1){
                                foundInt = false;
                                for(var h=0; h<LOCinterimTime.length; h++){
                                    if(LOCinterimTime[h].user === this.intervention.planning[f].user.idWeweb){
                                        foundInt = true;
                                        LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                        LOCinterimTime[h].time = LOCinterimTime[h].time + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    }
                                }
                                if(!foundInt){
                                    LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    LOCinterimTime.push({time:this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp, user:this.intervention.planning[f].user.idWeweb});
                                }
                            }
                        }
                    }
                    this.mainTechHour = ""+Math.floor(LOCmainTechTime / 3600);
                    this.mainTechMinute = ""+Math.floor(LOCmainTechTime % 3600 / 60);

                    for(var e=0; e<LOCinterimTime.length; e++){
                        if(e>0){
                            this.interimHour.push(""+Math.floor(LOCinterimTime[e] / 3600));
                            this.interimMinute.push(""+Math.floor(LOCinterimTime[e] % 3600 / 60));
                        }
                        else{
                            this.interimHour[0] = (""+Math.floor(LOCinterimTime[e] / 3600));
                            this.interimMinute[0] = (""+Math.floor(LOCinterimTime[e] % 3600 / 60));
                        }
                    }
                    if(LOCinterimTime.length === 0){
                        this.interimHour = [];
                        this.interimMinute = [];
                    }
                    for(var d=0; d<LOChelpTime.length; d++){
                        if(d>0){
                            this.helpHour.push(""+Math.floor(LOChelpTime[d] / 3600));
                            this.helpMinute.push(""+Math.floor(LOChelpTime[d] % 3600 / 60));
                        }
                        else{
                            this.helpHour[0] = (""+Math.floor(LOChelpTime[d] / 3600));
                            this.helpMinute[0] = (""+Math.floor(LOChelpTime[d] % 3600 / 60));
                        }
                    }
                    if(LOChelpTime.length === 0){
                        this.helpHour = [];
                        this.helpMinute = [];
                    }

                    this.cumulateHour = Math.floor(""+LOCcumulateTime / 3600);
                    this.cumulateMinute = Math.floor(""+LOCcumulateTime % 3600 / 60);
                    this.getInquiry(this.intervention._id);
                }
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #interventiondetailadmin {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .greyBack{
        background-color: #2b2b2b;
        color:#FFFFFF;
        font-family: 'BenchNine', sans-serif;
        font-size: 24px;
        padding-top: 15px;
        padding-bottom: 30px;
        .title{
            text-align: center;
            padding:5px;
        }
        .date{
            margin-top:-10px;
            text-align: center;
            font-size: 14px;
        }
        .img{
            margin:auto;
            text-align: center;
            margin-top:20px;
            .oneImg{
                display: inline-block;
                padding:15px;
                font-size: 14px;
                span{
                    display:block;
                }
                img{
                    display:block;
                    margin:auto;
                }
            }
            .allImg{
                font-size: 14px;
                display: inline-block;
                span{
                    display:block;
                }
                img{
                    display:block;
                    margin:auto;
                }
            }

            /* The Modal (background) */
            .modalActive {
              display: block !important; /* Hidden by default */
              position: fixed; /* Stay in place */
              z-index: 100; /* Sit on top */
              padding-top: 100px; /* Location of the box */
              left: 0;
              top: 0;
              width: 100%; /* Full width */
              height: 100%; /* Full height */
              overflow: auto; /* Enable scroll if needed */
              background-color: rgb(0,0,0); /* Fallback color */
              background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
            }
            .modalInactive {
              display: none !important; /* Hidden by default */
              position: fixed; /* Stay in place */
              z-index: 100; /* Sit on top */
              padding-top: 100px; /* Location of the box */
              left: 0;
              top: 0;
              width: 100%; /* Full width */
              height: 100%; /* Full height */
              overflow: auto; /* Enable scroll if needed */
              background-color: rgb(0,0,0); /* Fallback color */
              background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
            }

            /* Modal Content (Image) */
            .modal-content {
              margin: auto;
              display: block;
              width: 80%;
              max-width: 700px;
            }

            /* Add Animation - Zoom in the Modal */
            .modal-content{ 
              animation-name: zoom;
              animation-duration: 0.6s;
            }

            @keyframes zoom {
              from {transform:scale(0)} 
              to {transform:scale(1)}
            }

            /* The Close Button */
            .close {
              position: absolute;
              top: 15px;
              right: 35px;
              color: #f1f1f1;
              font-size: 40px;
              font-weight: bold;
              transition: 0.3s;
            }

            .close:hover,
            .close:focus {
              color: #bbb;
              text-decoration: none;
              cursor: pointer;
            }

            /* 100% Image Width on Smaller Screens */
            @media only screen and (max-width: 700px){
              .modal-content {
                width: 100%;
              }
            }
        }
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }
    .sideNav{
        background-clip: border-box;
        background-color: #FFF;
        background-origin: padding-box;
        box-sizing: border-box;
        background-color: #333;
        display: block;
        height: 100%;
        overflow:auto;
        box-shadow: 8px 0px 6px -6px #999;
        position:fixed;
        top:0;
        left:0;
        z-index:10;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navsidecontent{
        color:white;
        font-family: 'BenchNine', sans-serif;
        margin-top:65px;
        margin-left:30px;
        margin-right:30px;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navtitle{
        margin:10px;
        margin-top:15px;
        padding-top:5px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        border-top: 1px solid;
        border-color:#eee;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
                              
    }
    .navsubtitle{
        margin:7px;
        font-size: 18px;
        font-weight: 400;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:pointer;
    }
    .navsubtitle:hover{
        color:#999;
    }
    .noborder{
        border:none;
        margin-top:5px;
        padding-top:0px;
    }
    .logout{
        padding-top:50px;
        cursor:pointer;
    }
    
	/* width */
	::-webkit-scrollbar {
		width: 6px;
	}
	
	/* Track */
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	
	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .whiteback{
        color:black;
        background-color: white;
    }
    .smallFont{
        font-size: 15px;
    }
    .modalDivCenter{
        text-align: center;
    }
    .divSigImg{
        text-align: center;
        display: inline-block;
    }
    h4{
        margin:10px;
    }
    .twocolumns{        
        -webkit-column-count: 2; /* Old Chrome, Safari and Opera */
        -moz-column-count: 2; /* Old Firefox */
        column-count: 2;
    }
</style>